export const analytics = {
  projectProgress: "项目进度",
  hi: "你好",
  realProgress: "实际进度",
  welcomeBack: "欢迎回来",
  moduleStatistics: "模块统计",
  onTime: "准时",
  overdue: "逾期",
  constructionPercentage: "建设百分比",
  completed: "已完成",
  thisWeek: "本周",
  workForce: "劳动力",
  hours: "小时",
  completedTasks: "已完成的任务",
  analytics: "分析",
  addWidgets: "添加您的小部件以显示",
  projectStatistics: "项目统计",
  rfis: "RFIs",
  tasks: "任务",
  submittals: "提交",
  drawingsProgress: "图纸进度",
  drawingsCount: "图纸",
  inspections: "检查",
  inspectionCount: "检查",
  reports: "报告",
  reportCount: "报告",
  delayed: "延迟",
  closed: "已关闭",
  open: "打开",
  pending: "待处理",
  inProgress: "进行中",
  done: "已完成",
  revision: "修订",
  total: "总计",
  selectWidget: "选择您选择的小部件",
  widgetDisplayed: "所选小部件将显示在您的仪表板上",
  somethingWentWrong: "出了点问题",
  basic: "基本",
  manpower: "人力",
  workProgress: "工作进展",
  problem: "问题",
  delay: "延迟",
  categoryReports: "类别报告",
  projectAdvancement: "项目进展",
  remainingDays: "项目完成剩余天数",
  day: "天",
  progress: "进展",
  remaining: "剩余",
  error: "错误",
  notEnoughSpace: "没有足够的空间放置此小部件。",
  w: "周",
  progressOverTime: "随时间进展",
  week: "周",
  noDataAvailable: "没有可用的数据。",
};
